import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-1 ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export const GoldRule = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} aria-hidden="true">
    <span className="h-px w-12 bg-gold/70" />
    <span className="block h-1.5 w-1.5 rotate-45 border border-gold bg-gold/20" />
    <span className="h-px w-12 bg-gold/70" />
  </div>
);

export const Overline = ({ children, centered = false }) => (
  <div className={`flex items-center gap-3 ${centered ? "justify-center" : ""}`}>
    <span className="h-px w-8 bg-gold/60" aria-hidden="true" />
    <span className="overline-gold">{children}</span>
    {centered && <span className="h-px w-8 bg-gold/60" aria-hidden="true" />}
  </div>
);
